import { OpenNewTabTargetType } from '@voltmoney/types';
import { ROUTE } from '../../routes';
import sharedPropsService from "../../SharedPropsService";
import { DashboardActiveId } from "../../configs/constants";
import { generateUniqueId } from "../../configs/utils";
const tableSearchString = '';
// export const mockDATA = MockDataJson;
const searchIndex = [];
export const TestAction = async (action, _datastore, { navigate, goBack, setDatastore }) => {
    console.warn('**** onClosePopup Action Triggered ****', action);
};
export const onLoadAction = async (action, _datastore, { navigate, goBack, setDatastore }) => {
    console.warn('**** onClosePopup Action Triggered ****', action);
};
export const onClosePopup = async (action, _datastore, { hidePopup, navigate, asyncStorage }) => {
    console.warn('**** onClosePopup Action Triggered ****', action);
    const isPrevRouteLeads = action?.payload?.isPrevRouteLeads ? true : false;
    const dashboardActiveID = await sharedPropsService.getPartnerSideBarActiveId();
    await asyncStorage.set('GO_TO_REGISTER_LEADS', 'false');
    if (dashboardActiveID === DashboardActiveId.LEAD_PAGE) {
        await sharedPropsService.setPartnerLeadsList({
            customerMetadataList: [],
            nextToken: ''
        });
        await navigate(ROUTE.PARTNER_LEAD);
    }
    else {
        console.log('isPrevRouteLeads 123 : ', isPrevRouteLeads);
        isPrevRouteLeads ? await navigate(ROUTE.PARTNER_LEAD) : await hidePopup();
    }
    await asyncStorage.set('u_data', null);
};
export const onContinueJourney = async (action, _datastore, { navigate, hidePopup, asyncStorage, instrumentTrack }) => {
    const trackingId = await generateUniqueId();
    console.warn('**** onContinueJourney Action Triggered ****', action);
    await instrumentTrack("PLJ_LOAD_INITIATED", { trackingId: trackingId });
    await hidePopup();
    const borrowerAccountId = action.payload.value;
    const doesEmailExist = action?.payload?.doesEmailExist;
    const link = action.payload.shareLink;
    const partnerName = action.payload.userFullName;
    const partnerInterestRate = action?.payload?.partnerInterestRate;
    await asyncStorage.set('GO_TO_REGISTER_LEADS', 'false');
    await navigate(ROUTE.VOLT_APP, {
        borrowerAccountId: borrowerAccountId,
        doesEmailExist: doesEmailExist,
        shareLink: link,
        partnerName: partnerName,
        partnerInterestRate: partnerInterestRate
    });
    const pljLinkDetails = [link, partnerName, partnerInterestRate];
    await asyncStorage.set('u_data', null);
};
export const onCopyShareLink = async (action, _datastore, { setDatastore, clipboard, openNewTab }) => {
    console.warn('**** onContinueJourney Action Triggered ****', action);
    const link = action.payload.value;
    const partnerName = action.payload.partnerName;
    const partnerInterestRate = action?.payload?.partnerInterestRate;
    if (action.payload.widgetId === 'CopyLinkBtn') {
        await setDatastore(ROUTE.REGISTER_LEADS_SUCCESS, 'CopyLinkBtn', {
            label: 'Link copied'
        });
        clipboard.set(link);
        setTimeout(async () => {
            await setDatastore(ROUTE.REGISTER_LEADS_SUCCESS, 'CopyLinkBtn', {
                label: 'Copy link'
            });
        }, 2000);
    }
    if (action.payload.widgetId === 'ShareViaWhatsAppBtn') {
        const url = `https://api.whatsapp.com/send?text=Hi%2c%20Use%20Volt%20Money%20to%20open%20a%20credit%20line(OD)%20against%20mutual%20funds%20in%20just%205%20minutes%2e%20Use%20this%20link%20to%20apply%20now%2e%0a${link}%0aRegards%2c%0a${encodeURIComponent(partnerName)}`;
        openNewTab(url, OpenNewTabTargetType.blank);
    }
};
